/**
 * External Dependencies
 */
import $ from 'jquery'
import slick from 'slick-carousel'
import fancybox from '@fancyapps/fancybox'

import 'youtube-background'


//GSAP
import  gsap  from "gsap/dist/gsap";
import  ScrollTrigger  from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


$(() => {
  //console.log('Hello world');


  //Main Menu open/close
  $('.menu-open').on('click', function(e) {
    $('.overlay-menu').css('width','100%');
    e.preventDefault();
  });
  $('.menu-close').on('click', function(e) {
    $('.overlay-menu').css('width','0%');
    e.preventDefault();
  });


  //Slider loghi
  $('.slider-loghi').slick({
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    dots: false,
    responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 3
          }
        }
      ]
  });


  //Slider cards
  $('.slider-cards').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1.5,
    infinite: false,
    dotsClass: 'slick-dots slick-dots-grey',
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: true,
    dots: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  //slider-video-back
  $('.slider-video-back').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    dotsClass: 'slick-dots slick-dots-white',
    arrows: false,
    pauseOnHover: true,
    dots: true
  });



  //slider home citzaioni
  $('.slider-citazioni').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    dotsClass: 'slick-dots',
    arrows: false,
    pauseOnHover: true,
    dots: true
  });



  //Slider loghi
  $('.slider-100').slick({
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: true,
    dots: true
  });

  //Accordion
  $(".accordion-head").on('click', function(e) {
    $(".accordion-head").removeClass('accordion-head-open');
    $(this).addClass('accordion-head-open');
    if ($('.accordion-body').is(':visible')) {
      $(".accordion-body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion-body").is(':visible')) {
      $(this).next(".accordion-body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion-body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
    e.preventDefault();
  });


  //Video background
  $('[data-vbg]').youtube_background();

});




// COUNTER inViewport
$(function($, win) {
  $.fn.inViewport = function(cb) {
    return this.each(function(i,el){
      function visPx(){
        var H = $(this).height(),
            r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
        return cb.call(el, Math.max(0, t>0? H-t : (b<H?b:H)));
      } visPx();
      $(win).on("resize scroll", visPx);
    });
  };
}(jQuery, window));

jQuery(function($) { // DOM ready and $ in scope
  $(".counter").inViewport(function(px) { // Make use of the `px` argument!!!
    // if element entered V.port ( px>0 ) and
    // if prop initNumAnim flag is not yet set
    //  = Animate numbers
    if(px>0 && !this.initNumAnim) {
      this.initNumAnim = true; // Set flag to true to prevent re-running the same animation
      $(this).prop('Counter',0).animate({
        Counter: $(this).text()
      }, {
        duration: 8000,
        step: function (now) {
          $(this).text(Math.ceil(now));
        }
      });
    }
  });

});















//GSAP HOME PANEL SCROLL https://codepen.io/GreenSock/pen/ZEpNLZa || https://codepen.io/GreenSock/pen/YzygYvM
const sections = gsap.utils.toArray("section.slide-horizontal");
let maxWidth = 0;

const getMaxWidth = () => {
  maxWidth = 0;
  sections.forEach((section) => {
    maxWidth += section.offsetWidth;
  });
};
getMaxWidth();
ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

gsap.to(sections, {
  x: () => `-${maxWidth - window.innerWidth}`,
  ease: "none",
  scrollTrigger: {
    trigger: ".home-horizontal-slider",
    pin: true,
    scrub: true,
    end: () => `+=${maxWidth}`,
    invalidateOnRefresh: true
  }
});

sections.forEach((sct, i) => {
  ScrollTrigger.create({
    trigger: sct,
    start: () => 'top top-=' + (sct.offsetLeft - window.innerWidth/2) * (maxWidth / (maxWidth - window.innerWidth)),
    end: () => '+=' + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
    toggleClass: {targets: sct, className: "active"}
  });
});



//HOME - https://codepen.io/GreenSock/pen/vYNNvMj
gsap.to(".parallax-bg", {
  scrollTrigger: {
    scrub: true
  },
  y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
  ease: "none"
});

